<div class="card">
  <div class="col-xl ">
    <div class="card card-bg ">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-lg-12">
            <!--start card-->
            <div class="card-wrapper card-wrapper-responsive" style="margin-left: 25rem; margin-right: 25rem">
              <div class="card">
                <div class="card-body">
                  <div class="categoryicon-top">
                    <svg class="icon">
                      <use href="./content/svg/sprites.svg#it-user"></use>
                    </svg>
                    <span class="text" jhiTranslate = "autocertificazioni.soggettoRichiedente">Soggetto Richiedente</span>
                  </div>
                  <div class="form-check">
                    <input checked (click)="showMeStesso()" class="form-check-input" type="radio"
                           name="flexRadioDefault"
                           id="flexRadioDefault1">
                    <label class="form-check-label" for="flexRadioDefault1"
                    jhiTranslate="autocertificazioni.meStesso">
                      Me Stesso
                    </label>
                  </div>
                  <div class="form-check">
                    <input (click)="showFamiliari()" class="form-check-input" type="radio" name="flexRadioDefault"
                           id="flexRadioDefault2">
                    <label class="form-check-label" for="flexRadioDefault2"
                    jhiTranslate="autocertificazioni.familiari">
                      Familiari
                    </label>
                  </div>
                  <div *ngIf="showFamiliariForm == true">
                    <div class="card-header" id="Prova1">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne"
                                aria-expanded="true" aria-controls="collapseOne">
                          SIBONI ANDREA (SBNNDR78P25E730I) - 25/09/1978 - LUGO (RA)
                        </button>
                      </h5>
                    </div>
                    <div class="card-header" id="Prova2">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne"
                                aria-expanded="true" aria-controls="collapseOne">
                          SIBONI ANDREA (SBNNDR78P25E730I) - 25/09/1978 - LUGO (RA)
                        </button>
                      </h5>
                    </div>
                    <div class="card-header" id="Prova3">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne"
                                aria-expanded="true" aria-controls="collapseOne">
                          SIBONI ANDREA (SBNNDR78P25E730I) - 25/09/1978 - LUGO (RA)
                        </button>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--end card-->
          </div>
          <p class="text-center card-title h3 mb-3 mt-lg-5" jhiTranslate="autocertificazioni.autocertificazioniEmittibili">Autocertificazioni emittibili </p>
          <div class="card-responsive" style="text-align: center; padding: 50px 125px 125px">
            <div class="row" *ngIf="showMeStessoForm == true">
              <!--start card-->
              <div class="col-12 col-lg-4 mb-3">
                <div class="card-wrapper grow">
                  <div class="card">
                    <div class="card-body">
                      <div class="categoryicon-top">
                        <svg class="icon">
                          <use href="./content/svg/sprites.svg#it-file"></use>
                        </svg>
                        <span></span>
                      </div>
                      <a routerLink="">
                        <h3></h3>
                      </a>
                      <p class="card-text" jhiTranslate="autocertificazioni.addAutocertificazione">Clicca qui per emettere un' autocertificazione.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!--end card-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
